import { render, staticRenderFns } from "./AttachmentListItem.vue?vue&type=template&id=3641a18d&scoped=true"
import script from "./AttachmentListItem.vue?vue&type=script&lang=js"
export * from "./AttachmentListItem.vue?vue&type=script&lang=js"
import style0 from "./AttachmentListItem.vue?vue&type=style&index=0&id=3641a18d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3641a18d",
  null
  
)

export default component.exports